import {createApp} from 'vue'

import Enrol from './Enrol.vue'
import axios from "axios";
import Amplify from "aws-amplify";

import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';


/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import '../theme/variables.css';
/* Common CSS */
import './styles.css';

import router from "./Router";
import store from "@/services/VuexStore";


let initApp = () => {
  axios.get('/assets/config/config.json').then(res => {
    let config = res.data;

    Amplify.configure(config.amplifyConfig)

    // new Vue({
    //   render: h => h(Results),
    // }).$mount('#results')

    const app = createApp(Enrol)
      .use(IonicVue)
      .use(store)
      .use(router);

    // console.log(process.env.BASE_URL)
    app.provide('$config', res.data);

    app.mount('#enrol-vue');
  });
}

initApp();
// createApp(Results).mount('#results')
